import React from "react";
import {
    FacebookIcon,
    InstagramIcon,
    LinkedInIcon,
    XIcon,
    YouTubeIcon,
} from "./MediaKitSocialIcons";

type SocialLink = {
    label: string;
    href: string;
    Icon: React.ComponentType<{ className?: string }>;
};

const SOCIAL_LINKS: SocialLink[] = [
    {
        label: "LinkedIn",
        href: "https://www.linkedin.com/company/polaris-athlete",
        Icon: LinkedInIcon,
    },
    {
        label: "YouTube",
        href: "https://www.youtube.com/@polarisathlete",
        Icon: YouTubeIcon,
    },
    {
        label: "Instagram",
        href: "https://www.instagram.com/polarisathlete/",
        Icon: InstagramIcon,
    },
    {
        label: "X",
        href: "https://x.com/PolarisAthlete",
        Icon: XIcon,
    },
    {
        label: "Facebook",
        href: "https://www.facebook.com/p/Polaris-Athlete-61572197799349/",
        Icon: FacebookIcon,
    },
];

export default function FooterSocialLinks() {
    return (
        <nav className="landing-footer-social" aria-label="Polaris Athlete social media">
            {SOCIAL_LINKS.map(({ label, href, Icon }) => (
                <a
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="landing-footer-social-link"
                    aria-label={`Polaris Athlete on ${label}`}
                >
                    <Icon className="landing-footer-social-icon" />
                </a>
            ))}
        </nav>
    );
}
